import React from 'react';
import type { FormatterProps } from './type';
import { get, isEmpty } from 'lodash';
import {
  calculateDateGap,
  convertDateInstanceToDateString,
} from '../../../../helpers/dateHelper';

const LastEpisodeDetailsFormatter = ({
  row,
  fieldKey,
}: FormatterProps & { fieldKey: string }) => {
  if (!row || isEmpty(row.last_episode)) {
    return <span>-</span>;
  }
  const lastEpisode = row.last_episode;
  const details = lastEpisode.details;
  let value = get(details, [fieldKey], '-');
  const isDate = fieldKey === 'Date admitted';
  if (isDate) {
    value = get(lastEpisode, ['episode_opened_date'], '-');
  }
  if (fieldKey === 'Length of stay') {
    const lastEpisodeOpenedDate = get(
      lastEpisode,
      ['episode_opened_date'],
      '-',
    );
    const lastEpisodeClosedDate = get(
      lastEpisode,
      ['episode_closed_date'],
      null,
    );

    if (!lastEpisodeClosedDate) {
      value =
        calculateDateGap(lastEpisodeOpenedDate, new Date().toISOString()) || '';
    } else {
      value =
        calculateDateGap(lastEpisodeOpenedDate, lastEpisodeClosedDate) || '';
    }
  }
  return <span>{isDate ? convertDateInstanceToDateString(value) : value}</span>;
};

export default LastEpisodeDetailsFormatter;
